import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { Address, Dependent } from '../../../user/models/user-profile.model';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationModalComponent } from '../../../../shared/components/notification-modal/notification-modal.component';

@Component({
  selector: 'app-ambulance-assistance',
  imports: [
    FormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './ambulance-assistance.component.html',
  styleUrl: './ambulance-assistance.component.scss',
})
export class AmbulanceAssistanceComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() nameService: string = '';
  @Input() currentMapLocation: any = null;
  @Input() isLoadingLocation: boolean = false;
  @Input() showMapSearchInput: boolean = false;
  @Input() serviceData: any = null;
  @Input() set mapMovedManually(moved: boolean) {
    if (moved) {
      this.selectedAddress = null;
    }
  }
  @Output() addressSelected = new EventEmitter<any>();
  @Output() enableMapSearch = new EventEmitter<void>();
  @Output() disableMapSearch = new EventEmitter<void>();
  @Output() searchAddress = new EventEmitter<string>();


  isEditingCurrentLocation: boolean = false;
  isSearching: boolean = false;

  @ViewChild('searchInput') searchInput: any;
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  addresses: Address[] = [];
  dependent: Dependent[] = [];
  hideHeader = false;
  showAllAddresses = false;
  selectedAddress: any = null;
  selectedPatient = 'titular';
  reference: string = '';
  userProfile: any;
  contactoDeTelefono: String = '0';
  isBanamexAccount: boolean = false;
  showAllDependents = false;
  email: string= '';
  selectedName: string = '';

  private checkBanamexAccount(): void {
    const allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    const account = localStorage.getItem('account');
    this.isBanamexAccount = account ? allowedAccounts.includes(account) : false;
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = this.serviceData?.clSubServicio;
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  // contactoDeTelefono: String = '5558094624';

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private requestServ: RequestsService, private loader: LoaderService, private dialog: MatDialog) { }

  ngOnInit() {
    // Solo obtener de la ruta si no se pasó como Input
    if (!this.nameService) {
      this.nameService = this.route.snapshot.paramMap.get('nombre') || '';
    }
    this.hideHeader = this.route.snapshot.queryParamMap.get('hideHeader') === 'true';
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
      this.email = userObj.email || '';
    }
    this.checkBanamexAccount();
    this.getServiceContact();
    this.getDetailUser();
  }

  ngOnDestroy(): void {
    // Marcar que se necesita recargar la página al cerrar
    localStorage.setItem('needsPageReload', 'true');
  }

  ngAfterViewInit() {
    // Recargar direcciones si regresamos de agregar dirección
    const addressAdded = sessionStorage.getItem('addressAdded');
    if (addressAdded === 'true') {
      sessionStorage.removeItem('addressAdded');
      this.getDetailUser();
    }
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
          this.addresses = res.address;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  addNewDependent() {
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  goToConfirm() {
    if (!this.reference || this.reference.trim() === '') {
      this.dialog.open(NotificationModalComponent, {
        data: {
          type: 'info',
          title: 'Referencias',
          message: 'Agrega una referencia del lugar para ayudarnos a localizarte con mayor precisión.'
        }
      });
      return;
    }

    setTimeout(() => this.loader.show(), 0);
    const selectedName = this.selectedPatient === 'titular'
      ? this.nameOwner
      : this.selectedPatient;

    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);

    // Obtener accountId desde localStorage
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;

    // Obtener coordenadas de la dirección seleccionada o ubicación actual
    let latitude = '';
    let longitude = '';
    const currentCode = {
      cp:'',callenum:'', statecode:'', municipalityCode:''
    };

    console.log('=== INICIO goToConfirm ===');
    console.log('selected = ', this.selectedAddress)
    console.log('current  = ', this.currentMapLocation)
    console.log('selectedAddress == null:', this.selectedAddress == null);
    console.log('selectedAddress?.isCurrentLocation:', this.selectedAddress?.isCurrentLocation);
    console.log('currentMapLocation?.isCurrentLocation:', this.currentMapLocation?.isCurrentLocation);

    // Verificar si currentMapLocation es ubicación actual
    if (this.currentMapLocation?.isCurrentLocation) {
      console.log('CASO UBICACIÓN ACTUAL: Usando currentMapLocation');
      console.log('currentMapLocation.identifier:', this.currentMapLocation.identifier);
      latitude = this.currentMapLocation.lat.toString();
      longitude = this.currentMapLocation.lng.toString();
      currentCode.callenum = this.currentMapLocation.identifier || "Ubicación actual";
      currentCode.cp = this.currentMapLocation?.postalCode || "";
      currentCode.statecode = this.currentMapLocation?.codeEstado?.id || this.currentMapLocation?.codeEstado || "";
      currentCode.municipalityCode = this.currentMapLocation?.codeMunicipio?.id || this.currentMapLocation?.codeMunicipio || "";
    } else if (this.selectedAddress && !this.selectedAddress?.isCurrentLocation && this.selectedAddress?.idAddress) {
      console.log('CASO DIRECCIÓN GUARDADA');
      latitude = this.currentMapLocation.lat.toString();
      longitude = this.currentMapLocation.lng.toString();
      currentCode.cp = this.selectedAddress?.cp || this.currentMapLocation?.postalCode || "";
      currentCode.callenum = this.selectedAddress?.streetNumber || "";
      currentCode.statecode = this.selectedAddress?.codeent || "";
      currentCode.municipalityCode = this.selectedAddress?.codemun || "";
    } else {
      console.log('CASO DEFAULT: Usando currentMapLocation');
      latitude = this.currentMapLocation.lat.toString();
      longitude = this.currentMapLocation.lng.toString();
      currentCode.cp = this.currentMapLocation?.postalCode || this.currentMapLocation?.place?.address?.postcode || "";
      currentCode.callenum = this.currentMapLocation?.identifier || this.currentMapLocation?.streetNumber || this.currentMapLocation?.name || this.currentMapLocation?.place?.address?.road || "";
      currentCode.statecode = this.currentMapLocation?.country_code || this.currentMapLocation?.codeEstado?.id || "";
      currentCode.municipalityCode = this.currentMapLocation?.codemun || this.currentMapLocation?.codeMunicipio?.id || "";
    }

    console.log('currentCode final:', currentCode);
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: this.serviceData?.clServicio || 4,
        subServiceId: this.serviceData?.clSubServicio || 223,
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        cp: currentCode.cp,
        callenum: currentCode.callenum.substring(0, 99),
        stateCode: currentCode.statecode,
        municipalityCode: currentCode.municipalityCode,
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: firstName,
        paternalSurname: lastName,
        userSecondLastName: secondLastName,
        contactName: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
        userFirstNamePf: ownerFirstName,
        userLastNamePf: ownerLastName,
        userSecondLastNamePf: ownerSecondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: longitude,
        latitude: latitude,
        infoadicional:this.reference,
        email: this.email,
        incidentDescription:currentCode.callenum + '. Referencia: ' + this.reference,
      }
    };

    this.requestServ.sendAmbulanceRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Solicitud enviada correctamente', res);

        // Navegar a la página de detalles con el expediente
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        console.log('expediente:', expediente);

        // Crear objeto con los parámetros necesarios para queryParams
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: this.serviceData?.dsSubServicio || 'AMBULANCIA',
          clservicio: res.response.clservicio || this.serviceData?.clServicio || '4',
          dsservicio: this.serviceData?.dsServicio || 'Asistencia Médica',
          clsubservicio: res.response.clsubservicio || this.serviceData?.clSubServicio || '223',
          dssubservicio: this.serviceData?.dsSubServicio || 'Ambulancia',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };

        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };

        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          // Después de navegar, hacer la llamada automática con un pequeño delay
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al enviar solicitud', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }

  toggleAddresses() {
    this.showAllAddresses = !this.showAllAddresses;
  }

  goToAddAddress() {
    const navigationExtras: NavigationExtras = {
      queryParams: { returnUrl: this.router.url }
    };
    this.router.navigate(['/add-direccion'], navigationExtras);
  }

  selectAddress(address: any) {
    this.selectedAddress = address;

    // Si es ubicación actual, recargar ubicación real del usuario
    if (address.isCurrentLocation) {
      this.getCurrentLocation();
      return;
    }

    // Para direcciones guardadas
    this.disableMapSearch.emit();
    this.isEditingCurrentLocation = false;

    // Siempre emitir la dirección seleccionada al componente padre
    if (address.lat && address.lng) {
      const addressData = {
        lat: parseFloat(address.lat),
        lng: parseFloat(address.lng),
        address: `${
          address.streetNumber}
          Int ${address.interiorDepartament || ''},
          ${address.colony || ''}.${address.cp || ''},
          ${address.municipality || ''},
          ${address.state || ''}`,
        timestamp: Date.now()
      };
      this.addressSelected.emit(addressData);
    }
  }

  private getCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.getAddressFromCoordinates(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    }
  }

  private getAddressFromCoordinates(lat: number, lng: number) {
    if (typeof google !== 'undefined' && google.maps) {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results: any, status: any) => {
        if (status === 'OK' && results && results.length > 0) {
          // Buscar la mejor dirección (evitar Plus Codes y priorizar direcciones con calles)
          let bestAddress = results[0].formatted_address;

          for (let result of results) {
            const address = result.formatted_address;
            // Evitar Plus Codes (formato como "J756+42")
            if (!address.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
              // Priorizar direcciones que contengan números de calle
              if (address.match(/\d+/)) {
                bestAddress = address;
                break;
              }
              // Si no tiene números, usar la primera dirección válida
              if (!bestAddress.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
                bestAddress = address;
              }
            }
          }

          const addressData = {
            lat,
            lng,
            address: bestAddress,
            timestamp: Date.now(),
            isCurrentLocation: true
          };
          this.addressSelected.emit(addressData);
        } else {
          // Fallback si falla la geocodificación
          const addressData = {
            lat,
            lng,
            address: 'Ubicación actual',
            timestamp: Date.now(),
            isCurrentLocation: true
          };
          this.addressSelected.emit(addressData);
        }
      });
    } else {
      // Fallback si Google Maps no está disponible
      const addressData = {
        lat,
        lng,
        address: 'Ubicación actual',
        timestamp: Date.now(),
        isCurrentLocation: true
      };
      this.addressSelected.emit(addressData);
    }
  }

  toggleEditCurrentLocation(event: Event) {
    event.stopPropagation();
    this.isEditingCurrentLocation = !this.isEditingCurrentLocation;

    if (this.isEditingCurrentLocation) {
      this.enableMapSearch.emit();
      setTimeout(() => {
        this.initializeAutocomplete();
      }, 100);
    } else {
      this.disableMapSearch.emit();
      this.isSearching = false;
    }
  }

  onSearchInput(event: any) {
    const value = event.target.value;
    if (value && value.length > 2) {
      this.isSearching = true;
      this.searchAddress.emit(value);
    } else {
      this.isSearching = false;
    }
  }

  initializeAutocomplete() {
    if (!this.searchInput || !this.searchInput.nativeElement) {
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      return;
    }

    try {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchInput.nativeElement,
        {
          types: ['establishment', 'geocode'],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.isSearching = false;

        if (place && place.geometry && place.geometry.location) {
          const addressData = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            address: place.formatted_address || place.name || 'Ubicación seleccionada'
          };
          this.addressSelected.emit(addressData);
        }
      });
    } catch (error) {
      console.error('Error inicializando autocompletado:', error);
    }
  }

  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.isSearching = false;
  }

  toggleDependents() {
    this.showAllDependents = !this.showAllDependents;
  }

}
